import { useState } from 'react'

import type { Survey } from 'app/common/types/surveys'
import PlainButtonAsLink from 'app/common/ui-next/plain-button-as-link'
import PlainButton from 'app/common/ui-next/plain-button'
import PlainIcon, { iconTypes } from 'app/common/ui-next/plain-icon'
import { useDeleteSurvey, useRestoreSurvey } from 'app/dataProviders/surveys/hooks'
import { DeleteSurveyConfirmModal } from '../../../Details/DeleteConfirmModal'

import styles from './SurveyActions.module.scss'

type Props = {
  survey: Survey
  archived: boolean
  onSuccess: () => void
}

export const SurveyActions = ({
  survey,
  archived,
  onSuccess,
}: Props) => {
  const [confirm, setConfirm] = useState(false)
  const { pending: restoring, submit: restoreSurvey } = useRestoreSurvey({
    surveyId: survey.id,
    onSuccess,
  })
  const { pending, submit } = useDeleteSurvey({
    surveyId: survey.id,
    onSuccess: () => {
      setConfirm(false)
      onSuccess()
    },
  })

  const handleRestore = async () => {
    await restoreSurvey()
  }

  const handleDelete = async () => {
    await submit()
  }

  const handleCancel = () => {
    if (!pending) setConfirm(false)
  }

  if (archived) {
    return (
      <PlainButton
        className={styles.restoreButton}
        ariaLabel={restoring ? 'Восстановление опроса' : 'Восстановить опрос'}
        disabled={restoring}
        onClick={handleRestore}
      >
        {restoring ? 'Восстановление…' : 'Восстановить'}
      </PlainButton>
    )
  }

  return (
    <>
      <PlainButtonAsLink
        disabled={pending}
        ariaLabel={`Удалить опрос «${survey.title}»`}
        onClick={() => setConfirm(true)}
      >
        <PlainIcon type={iconTypes.CROSS_BOLD} width={14} height={14} />
      </PlainButtonAsLink>
      {confirm && (
        <DeleteSurveyConfirmModal
          surveyTitle={survey.title}
          deleting={pending}
          onCancel={handleCancel}
          onConfirm={handleDelete}
        />
      )}
    </>
  )
}
